import Painel from "../painel/router/index.js";
import Comportamentos from "../comportamentos/router/index.js";
import Avaliacao from "../avaliacao/router/index.js";
import Avaliacoes from '../avaliacoes/router/index.js';

const router = [...Painel, ...Comportamentos, ...Avaliacao, ...Avaliacoes];

export default router;
